import * as React from "react";
import { observer } from "mobx-react";

import { UitkTertiaryButton } from "uitk-react-button";
import { UitkLayoutConditionalGridSpan, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading } from "uitk-react-text";

import { useLocalization } from "@shared-ui/localization-context";

import { Dates } from "components/shared/Dates/Dates";
import { locKeys as locKeysFlight } from "components/flexComponents/WizardFlightPWA/components/l10n";
import { MultiCityFlightLeg } from "components/flexComponents/WizardFlightPWA/components/MultiCityFlightLeg";

import { locKeys } from "../l10n";
import { StaySomewhereElse } from "./StaySomewhereElse";
import { PackageSubLOBProps } from "../typings";

export const PackageMulticityFlight = observer(({ packageWizardState, routeStore }: PackageSubLOBProps) => {
  const { formatText } = useLocalization();

  const addLegColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const fssseColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 4 };
  const datesHotelColSpan: UitkLayoutConditionalGridSpan = { small: 2, medium: 8 };

  const {
    addALeg,
    config,
    isFlightHotelMultiFormValid,
    listOfAdditionalLegs,
    updateInvalidFormsState,
  } = packageWizardState;

  if (isFlightHotelMultiFormValid) {
    updateInvalidFormsState();
  }

  return (
    <>
      <MultiCityFlightLeg lobState={packageWizardState} routeStore={routeStore} showSwapLocationsControl={true} />

      {listOfAdditionalLegs.length < config.multiCityFlight.maxNumberOfAdditionalLegs && (
        <UitkLayoutGridItem colSpan={addLegColSpan}>
          <div>
            <UitkTertiaryButton icon="add" text={formatText(locKeysFlight.addFlightLabel)} onClick={addALeg} />
          </div>
        </UitkLayoutGridItem>
      )}

      <UitkLayoutGridItem colSpan="all">
        <UitkHeading level={2} size={600}>
          {formatText(locKeys.hotelSectionLabel)}
        </UitkHeading>
      </UitkLayoutGridItem>

      <StaySomewhereElse lobState={packageWizardState} colSpan={fssseColSpan} />

      <Dates lobState={packageWizardState} isPartialStay={true} colSpan={datesHotelColSpan} />
    </>
  );
});
